import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CB, COFIDIS, CRYPTO_LYZI } from '../../../constants/paymentMethods';

import CheckoutIframe from '../../iframes/checkout';
import LyziIframe from '../../iframes/lyzi/LyziIframe';
import CofidisIframe from '../../iframes/cofidis/CofidisIframe';

const FunnelPaymentStep = ({
    userInfo,
    partnerId,
    partnerName,
    order,
    cartTotalValue,
    paymentType,
    checkoutAllowed
}) => {
    return (
        <React.Fragment>
            {paymentType === CB && checkoutAllowed && (
                <CheckoutIframe userInfo={userInfo} partnerId={partnerId} order={order} />
            )}

            {paymentType === COFIDIS && <CofidisIframe order={order} />}

            {paymentType === CRYPTO_LYZI && (
                <LyziIframe
                    userInfo={userInfo}
                    partnerId={partnerId}
                    partnerName={partnerName}
                    order={order}
                    cartTotalValue={cartTotalValue}
                />
            )}
        </React.Fragment>
    );
};

FunnelPaymentStep.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    order: PropTypes.object,
    cartTotalValue: PropTypes.number,
    paymentType: PropTypes.string
};

const mapStateToProps = state => {
    return {
        checkoutAllowed:
            state.ebon.ebons.ebonPaymentConfig && state.ebon.ebons.ebonPaymentConfig.checkoutAllowed
    };
};

export default connect(mapStateToProps)(FunnelPaymentStep);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/FunnelPaymentStep.js